import useComputed from '@/hooks/use-computed'
import api from '@/services/api/myenrol'
import { immerable } from "immer"
import { useState } from 'react'
import { orderBy } from 'lodash'

class MyInfo {

	[immerable] = true

	constructor(params) {
		this.authRedirectUrl = params.authRedirectUrl
		this.companyAppointment = params.companyAppointment
		this.companyStatus = params.companyStatus
		this.companyTypes = params.companyTypes
		this.mobile_number = params.mobile_number
		this.countryOfIncorp = params.countryOfIncorp
		this.nationality = params.nationality

	}
}

const useMyInfo = (requestId) => {

	const [items, setItems] = useComputed([])

	const [meta, setMeta] = useState(null)

	const [currentItem ,setCurrentItem] = useState(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState()

	async function fetch(parameter) {
		setLoading(true)

		const params = parameter ? parameter : "";

		const [error, data] = await api.getRequest({
			params
		})

		setLoading(false)

		if (error) {
			return setError(error)
		}

		const serializedData = serialize(data)
		const newItem = new MyInfo(serializedData)
		return setCurrentItem(newItem)
	}

	async function find( parameter ) {

		setLoading(true)
		const params = parameter ? parameter : "";

		const [error, data] = await api.getRequest({params});

		setLoading(false)

		if (error) {
			return setError(error)
		}

		return data
	}

	function serialize(entry) {
		return {
			authRedirectUrl: entry.authRedirectUrl,
			companyAppointment: orderBy(entry.companyAppointment, ["name"], ['asc']),
			companyStatus: orderBy(entry.companyStatus, ["name"], ['asc']),
			companyTypes: orderBy(entry.companyTypes, ["name"], ['asc']),
			mobile_number: orderBy(entry.mobileNumber, ["name"], ['asc']),
			countryOfIncorp: entry.countryOfIncorp.sort((x,y)=> x.name.toUpperCase() === "SINGAPORE" ? -1 : y.name.toUpperCase() === "SINGAPORE" ? 1 :  x.name.localeCompare(y.name)),
			nationality: orderBy(entry.nationality, ["name"], ['asc']),
		}
	}

	function view(id) {
		const newCurrentItem = items.find(item => item.id === id)
		setCurrentItem(newCurrentItem)
	}

	return {
		error,
		fetch,
		items,
		currentItem,
		setCurrentItem,
		loading,
		setItems,
		view,
		find
	}

}

export default useMyInfo;
